import { CompRef, DocumentServicesObject } from '@wix/document-services-types';
import { getBuilderDataByCompType } from '../../manifestUrlResolverService/utils';
import {
  ActionNames,
  NativeActionsList,
  SystemActionsList,
} from '@wix/editor-platform-host-integration-apis';
import { EditorPointer, EditorPointerAPI } from '@wix/editorx-core-api';

export const getAppData = (
  compType: string,
  documentServicesAPI: DocumentServicesObject,
) => {
  const { appDefinitionId } = getBuilderDataByCompType(compType);

  return documentServicesAPI.platform.getAppDataByAppDefId(appDefinitionId);
};

export const getAppDataFromEditorPointer = (
  editorPointer: EditorPointer<CompRef>,
  editorPointerAPI: EditorPointerAPI,
  documentServicesAPI: DocumentServicesObject,
) => {
  const compRef = editorPointerAPI.getDocumentPointer(editorPointer);

  const compType = documentServicesAPI.components.getType(compRef);

  return getAppData(compType, documentServicesAPI);
};

export const hasData = <T extends {}>(object?: T | null) =>
  !!object && Object.keys(object).length > 0;

export const isActionName = (actionName: string): actionName is ActionNames =>
  Object.values({ ...NativeActionsList, ...SystemActionsList }).some(
    (name) => name === actionName,
  );

export const objectMap = <T, U>(
  obj: Record<string, T>,
  fn: (value: T, key: string, index: number) => U,
): Record<string, U> =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value], index) => [
      key,
      fn(value, key, index),
    ]),
  );

export const objectFilter = <T>(
  obj: Record<string, T>,
  fn: (value: T, key: string, index: number) => boolean,
): Record<string, T> =>
  Object.fromEntries(
    Object.entries(obj).filter(([key, value], index) => fn(value, key, index)),
  );
